export const transformPayrollData = (payrollData) => {
  return payrollData.map((item) => {
    const grossDetails = Object.fromEntries(
      item?.totalGrossPayDetails?.map((d) => [d?.displayText, d?.value])
    );
    const deductionDetails = Object.fromEntries(
      item?.totalDeductionDetails?.map((d) => [d?.displayText, d?.value])
    );

    return {
      "Employee Number": item?.employeeId,
      "Employee Name": item?.employeeName,
      "Join Date": item?.dateOfJoining || "",
      "Left Date": item?.leftDate || "",
      Status: item?.employeeStatus || "",
      "Days in Month": item?.daysInMonth || "",
      "LOP (Loss of Pay)": deductionDetails?.["LOP (Loss of Pay)"] || "",
      "Basic Salary": grossDetails?.["BASIC SALARY"] || "",
      "HRA (House Rent Allowance)":
        grossDetails?.["HRA (House Rent Allowance)"] || "",
      "Conveyance Allowance": grossDetails?.["CONVEYANCE ALLOWANCE"] || "",
      "Medical Allowance": grossDetails?.["MEDICAL ALLOWANCE"] || "",
      "Special Allowance": grossDetails?.["SPECIAL ALLOWANCE"] || "",
      "EPA (Employer Pension Account, if applicable)":
        deductionDetails?.["EPA (Employer Pension Account)"] || "",
      "Gross Salary": item?.totalGrossPay,
      "PF (Provident Fund)": deductionDetails?.["PF"] || "",
      "Professional Tax": deductionDetails?.["PROFESSIONAL TAX"] || "",
      "Income Tax": deductionDetails?.["INCOME TAX"] || "",
      "Employee PF Contribution":
        deductionDetails?.["EMPLOYEE PF CONTRIBUTION"] || "",
      "Total Deductions": item?.totalDeduction,
      "Net Pay": item?.totalNetPay,
    };
  });
};
